import RunnerSafeType from "../../enums/RunnerSafeType.js";

// @see https://www.mlb.com/glossary/standard-stats/wild-pitch
// @see https://baseball.fandom.com/wiki/Wild_pitch
// In baseball, a wild pitch (abbreviated WP) is charged to a pitcher when a pitch is too high, too short, or too wide of home plate for the catcher to field with ordinary effort, thereby allowing the batter and/or one or more baserunners to advance or to score. 
const classifiesAsWildPitch = function(runnerSafe) {
    switch (runnerSafe) {
        case RunnerSafeType.OnWildPitch.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsWildPitch;
